export default __webpack_public_path__ + "static/decorist-4-b-03e7a996c449cdeefdfbd9868c79b89e.webp";